import type { VersionSnapshot } from '../types';

interface SnapshotModalProps {
  snapshots: VersionSnapshot[];
  onClose: () => void;
}

export default function SnapshotModal({ snapshots, onClose }: SnapshotModalProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-lg w-full max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">版本快照记录</h3>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-4">
            {snapshots.map((snapshot, index) => (
              <div key={snapshot.version} className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <div className="flex items-center gap-2">
                      <h4 className="text-base font-semibold text-gray-900">{snapshot.version}</h4>
                      {index === 0 && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-teal-100 text-teal-800">
                          当前版本
                        </span>
                      )}
                    </div>
                    <p className="text-sm text-gray-500 mt-1">{snapshot.description}</p>
                  </div>
                  <div className="text-sm text-gray-500">{snapshot.createTime}</div>
                </div>

                <div>
                  <h5 className="text-sm font-medium text-gray-700 mb-2">更新内容：</h5>
                  <ul className="space-y-1">
                    {snapshot.changes.map((change, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-gray-600">
                        <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                        <span>{change}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200">
          <button onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors whitespace-nowrap">
            关闭
          </button>
        </div>
      </div>
    </div>
  );
}
